import { request, requestData } from '@/lib/api-client';
import type { AuthTokens, AuthUser } from './types';

/**
 * Phone number, then a code. No password anywhere.
 *
 * Unlike the customer app, no name is sent on verify. There a number nobody
 * has used before creates an account; a rider account is created by the
 * PLATFORM in the admin panel — the role granted, then a `riders` row with a
 * vehicle on it. Someone signing in on an unknown number gets a session with
 * no rider profile behind it, which this app names for what it is rather than
 * leaving them on a run sheet that will never fill.
 */
export const authApi = {
  /**
   * Returns the dev code outside production, so signing in needs no SMS
   * contract while the platform is being built. Null in a real deployment.
   */
  async requestOtp(phone: string): Promise<string | null> {
    const data = await requestData<{ devCode?: string }>('/auth/otp/request', {
      method: 'POST',
      body: { phone, purpose: 'LOGIN' },
      anonymous: true,
    });
    return data.devCode ?? null;
  },

  verifyOtp(input: { phone: string; code: string }): Promise<AuthTokens> {
    return requestData<AuthTokens>('/auth/otp/verify', {
      method: 'POST',
      body: { phone: input.phone, code: input.code, purpose: 'LOGIN' },
      anonymous: true,
    });
  },

  me(): Promise<AuthUser> {
    return requestData<AuthUser>('/auth/me');
  },

  logout(refreshToken: string): Promise<void> {
    return request<void>('/auth/logout', {
      method: 'POST',
      body: { refreshToken },
      anonymous: true,
    });
  },
};
